import React, { Fragment, useEffect } from 'react'
import EntityScrollBar from './EntityScrollBar'
import { Typography } from '@material-ui/core';
import { getI18nFormattedMessage } from '../../../../utils/intl';
import { FormTextField } from '../../../../components';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

const Overview = (props) => {
  const {
    setCurrentTab,
    apisCount,
    applicationsCount,
    setApiGroupDescription,
    apiGroupDescription,
    classes,
    apiGroupUuid,
  } = props

  const getEntitiesCounts = () => {
    const array = [
      {
        entity: "APIs",
        count: apisCount,
      },
      {
        entity: "Applications",
        count: applicationsCount,
      },
    ]
    return array;
  };

  const params = useParams();
  const currentTab = params?.tabName;
  const isCurrentTab = currentTab === 'overview';

  useEffect(() => {
    if (isCurrentTab) {
      setCurrentTab('add-api-group-overview-tab');
    }
  }, [currentTab])

  return (
    <Fragment>
      <EntityScrollBar
        setActiveTab={setCurrentTab}
        entities={getEntitiesCounts()}
        apiGroupUuid={apiGroupUuid}
      />
      <div className={classes.contentPadding}>
        <Typography className={classes.detailsHeading} variant='h4'>{getI18nFormattedMessage('label.application.details.smalltitle.details')}</Typography>
        <FormTextField
          id='add-api-group-description-field'
          fieldContainerClass={classes.apiGroupdescription}
          name={getI18nFormattedMessage('label.rate.quota.description')}
          helperText={getI18nFormattedMessage('label.maximum.length.255')}
          handleChange={(value) => setApiGroupDescription(value)}
          value={apiGroupDescription}
          rows={5}
          maxLength="255"
          multiline={true}
          optional
        />
      </div>
    </Fragment>
  )
}

Overview.propTypes = {
  setCurrentTab: PropTypes.func,
  apisCount: PropTypes.number,
  setApiGroupDescription: PropTypes.func,
  apiGroupDescription: PropTypes.string,
  classes: PropTypes.object,
  apiGroupUuid: PropTypes.string,
  applicationsCount: PropTypes.number,
}

export default Overview;
